import merge from 'lodash/merge';

import { StylesDataType } from '../../types';

export const commonStyles = {
  outerContainer: (data: StylesDataType): object => merge({}, {
    display: 'block',
    textDecoration: 'none !important',
    font: 'inherit !important',
  }, data.style?.outerContainer ?? {}),

  container: (data: StylesDataType): object => merge({}, {
    display: 'flex !important',
    flexDirection: 'column !important',
    justifyContent: 'space-between !important',
    boxSizing: 'border-box !important',
    font: '13px/18px Arial,Helvetica CY,Nimbus Sans L,sans-serif!important',
    margin: '0 !important',
    padding: '0 !important',
    background: 'none !important',
    position: 'relative !important',
    '&:hover $footer': {
      color: '#000000 !important',

      '& $footerCog svg > g > path': {
        fill: '#000000 !important',
        stroke: '#fff !important',
        filter: 'drop-shadow(0px 0px 1px rgba(0, 0, 0, .7))',
      },
    },
  }, data.style?.container ?? {}),

  sections: (data: StylesDataType): object => merge({}, {
    display: 'flex',
    justifyContent: 'space-between !important',
    height: '100% !important',
    padding: '0 !important',
    margin: '0 !important',
    flexWrap: 'wrap !important',
    gap: '10px !important',
    '& $section': {
      flex: '1 0 49% !important',
      boxSizing: 'border-box !important',
    },
  }, 'sections' in data.style ? data.style?.sections : {}),

  section: (data: StylesDataType): object => merge({}, {}, 'section' in data.style ? data.style?.section : {}),

  list: (data: StylesDataType): object => merge({}, {
    listStyle: 'none !important',
    margin: '0 !important',
    padding: '0 !important',
  }, data.style?.list ?? {}),

  listItem: (data: StylesDataType): object => merge({}, {
    listStyleType: 'none !important',
  }, data.style?.item ?? {}),

  listItemLink: (data: StylesDataType): object => merge({}, {
    display: 'inline-block !important',
    textDecoration: 'none !important',
  }, data.style?.itemLink ?? {}),

  footer: (data: StylesDataType): object => merge({}, {
    display: 'flex !important',
    flexWrap: 'wrap !important',
    justifyContent: 'space-between !important',
    flexDirection: 'row !important',
  }, data.style?.footer ?? {}),

  footerRight: (data: StylesDataType): object => merge({}, {
    position: 'relative !important',
    textAlign: 'right !important',
    marginLeft: 'auto !important',
  }, 'footerRight' in data.style ? data.style.footerRight : {}),

  footerCog: (data: StylesDataType): object => merge({}, {
    display: 'inline-block !important',
    height: '16px !important',
    width: '16px !important',
    verticalAlign: 'middle !important',

    '&:hover': {
      cursor: 'pointer !important',
    },

    '& svg > g > path': {
      // stroke: '#a3afc5 !important',
      strokeWidth: 1,
      filter: 'drop-shadow(0px 0px 1px rgba(255, 255, 255, .7))',
    },
  }, 'footerCog' in data.style ? data.style.footerCog : {}),

  footerSettings: (data: StylesDataType): object => merge({}, {
    display: 'inline-block !important',
    paddingLeft: '10px !important',
    '&:hover $footerSettingsModal': {
      display: 'block !important',
    },
  }, 'footerSettings' in data.style ? data.style.footerSettings : {}),

  footerSettingsModal: (data: StylesDataType): object => merge({}, {
    position: 'absolute !important',
    padding: '10px !important',
    background: '#ffffff !important',
    boxShadow: '0 4px 8px 0 rgba(0,0,0,0.15) !important',
    border: 'solid 1px #d8dde6 !important',
    borderRadius: '3px !important',
    right: '0 !important',
    bottom: '0 !important',
    display: 'none !important',
    marginBottom: '17px !important',

    '& ul': {
      listStyle: 'none !important',
      padding: '0 !important',
      margin: '0 !important',
      whiteSpace: 'nowrap !important',
      textAlign: 'left !important',

      '& li': {
        '& a': {
          color: '#16325c !important',
          textDecoration: 'none !important',
          display: 'block',
          padding: '10px 20px !important',
          transition: '0.2s ease-in-out',

          '&:hover': {
            color: '#196eed !important',
          },
        },
      },
    },
  }, 'footerSettingsModal' in data.style ? data.style.footerSettingsModal : {}),
}
